import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Page from '../Page.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import FormPartialEdit from './FormPartialEdit.js';
import OfferAddon from '../../models/OfferAddon';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const Edit = (props) => {
  const navigate = useNavigate();
  let offerAddonObj = new OfferAddon();
  const [offerAddon, setOfferAddon] = useState(offerAddonObj.toStateJson());
  const [fetchApi] = getApi('showOfferAddon')
  const [updateApi] = getApi('updateOfferAddon');
  const params = useParams();

  useEffect(() => {
    getRecord({ id: params.id })
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setOfferAddon((new OfferAddon(response.data.offer_addon)).toStateJson());
    } catch(error) {
      toast.error("Cannot Fetch Data !")
    }
  }

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      navigate("/offer_addons");
      toast.success("Updated SuccessFully");
    } catch(error) {
      let offerAddonObj = new OfferAddon(offerAddon);
      offerAddonObj.set_api_errors(error.data.data.errors);
    }
  }

  const onUpdateClick = () => {
    try{
      updateRecord((new OfferAddon(offerAddon)).toEditApiJson());
    } catch(error){
      setOfferAddon(new OfferAddon(offerAddon));
    }
  }

  const handleCancelFunction = () => {
    navigate('/offer_addons');
  }

  return <Page
      uiPage={uiManager.getUiPage(PAGES.EditOfferAddonPage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Offer Addons List", url: '/offer_addons' }, { label: "Edit Offer Addon" }]}
      className={'edit-offer-addon-page'}
    >
      <PageContentWrapper contentHeading={"Edit Offer Addon"}>
        <div className='m-3'>
          <div className='mb-4 col-md-12'>
            <form className="row g-3" autoComplete="off">
              <FormPartialEdit offerAddon={offerAddon} setOfferAddon={setOfferAddon} />
              <div className='mb-4 col-md-12'>
                <div >
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={onUpdateClick}>Update Offer Addon</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
}

export default Edit;
